import { NUTRITION_FACTS_PANEL_SELECTOR } from "./util.js";

export const exposeWidth = () => {
  const assignWidthProperty = () => {
    const labelDiv = document.querySelector(NUTRITION_FACTS_PANEL_SELECTOR);
    if (labelDiv) {
      // Note: This variable `--print-max-width` is used for several interactive features, not only for print.
      document.documentElement.style.setProperty("--print-max-width", `${labelDiv.clientWidth}px`);
    }
  };

  assignWidthProperty();

  /* Expose the label width as a custom ::root property */
  const mutationObserver = new MutationObserver(assignWidthProperty);
  mutationObserver.observe(document.querySelector("#label-and-claim-div"), {
    attributes: true,
    childList: true,
    subtree: true,
  });
};
